/** BroadcastChannel name for facet selection messages. */
export const FACETS_CHANNEL = "spaestiem-facets"

/**
 * Sent by <facets-view> on every selection change. Subscribers execute the
 * `query` (a CONSTRUCT) to get the matching triples; a null query means
 * "no filter active, show everything".
 */
export type FacetSelectionMsg = {
  type: "facet-selection"
  classUri: string | null
  query: string | null
}
